import { isUndefined } from './unit';
/**
 * Creates a throttled function that only invokes `func` at most once per animation frame.
 *
 * @param func - The function to throttle.
 * @link https://developer.mozilla.org/en-US/docs/Web/API/window/requestAnimationFrame
 */
export function rafThrottle(func) {
    let rafId;
    const pending = () => !isUndefined(rafId);
    const cancel = () => {
        if (isUndefined(rafId))
            return;
        window.cancelAnimationFrame(rafId);
        rafId = undefined;
    };
    function throttled(...args) {
        if (pending())
            return;
        rafId = window.requestAnimationFrame(() => {
            func.apply(this, args);
            rafId = undefined;
        });
    }
    throttled.cancel = cancel;
    throttled.pending = pending;
    return throttled;
}
